import { Toaster } from '../ui/sonner';

export function Layout({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <main className="container max-w-4xl mx-auto">
        {children}
      </main>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default Layout;
